var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFoodPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80003 3.80027L12.2001 6.20032M13.5045 4.88749C13.8217 4.57034 13.9999 4.14016 14 3.69158C14.0001 3.243 13.8219 2.81277 13.5048 2.49554C13.1876 2.17831 12.7574 2.00006 12.3089 2C11.8603 1.99994 11.4301 2.17809 11.1128 2.49524L3.10517 10.5048C2.96586 10.6437 2.86284 10.8147 2.80517 11.0028L2.01256 13.6141C1.99705 13.666 1.99588 13.7211 2.00917 13.7736C2.02246 13.8261 2.04971 13.874 2.08804 13.9123C2.12637 13.9506 2.17433 13.9777 2.22686 13.9909C2.27938 14.0042 2.3345 14.0029 2.38636 13.9873L4.99819 13.1953C5.18609 13.1381 5.3571 13.0357 5.49619 12.8971L13.5045 4.88749Z",
    stroke: "#404040",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoodPen);
export default __webpack_public_path__ + "static/media/icon_foodPen.90f615b6a2a33397826b7e6978079ecc.svg";
export { ForwardRef as ReactComponent };